// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__5cAI3","icon":"EnquiryForm_icon__2DYpG","heading":"EnquiryForm_heading__Mczxk","field":"EnquiryForm_field__1PJWn","error":"EnquiryForm_error__1Y6zJ"};